export default __webpack_public_path__ + "c0cec07b9203f130bc1f0913534bbebf.png";